module.exports = __webpack_public_path__ + "img/CL.00b3b641.jpg";